import React from 'react';

export const TileHeader = ({ text = '' }) => <>{text}</>;
